module.exports = __webpack_public_path__ + "img/ico-attention-red.c2e29a1e.svg";